import { QUERY_KEYS } from "@/libraries/constant";
import type { GetRemindersParamsSchema } from "@/schemas";
import { reminderService } from "@/services/reminder";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import isEmpty from "lodash/isEmpty";

export const getReminders = (params?: GetRemindersParamsSchema) =>
	infiniteQueryOptions({
		queryKey: [QUERY_KEYS.GET_REMINDERS, ...(!isEmpty(params) ? [params] : [])],
		initialPageParam: 1,
		queryFn: ({ pageParam }) =>
			reminderService.reminders({ ...params, page: pageParam, limit: 25 }),
		getNextPageParam: (lastPage) => lastPage?.meta?.next_page,
		select: (res) => res?.pages?.flatMap((p) => p?.reminders) || [],
	});

export const getRemindersMeta = (params?: GetRemindersParamsSchema) =>
	queryOptions({
		queryKey: [
			QUERY_KEYS.GET_REMINDERS_FLAT,
			...(!isEmpty(params) ? [params] : []),
		],
		queryFn: () =>
			reminderService.reminders({
				...params,
				page: params?.page ?? 1,
				limit: params?.limit ?? 25,
			}),
	});

export const getReminder = (id: number) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_REMINDER, id],
		queryFn: () => reminderService.detail(id),
		enabled: !!id,
	});
